import {Component, EventEmitter, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-sts-button',
  templateUrl: './sts-button.component.html',
  exportAs: 'app-sts-button'
})
export class StsButtonComponent implements OnInit {
  noCmsText = true;
  @Input() disabled = false;
  @Input() buttonType = 'submit';
  @Input() key: string;
  @Input() submit: EventEmitter<boolean> = null;

  formSubmitted = false;
  private isProd = false;

  constructor() {
  }

  ngOnInit() {
    if (this.submit) {
      this.submit.subscribe((b: boolean) => {
        this.formSubmitted = b;
      });
    }
  }

  onSubmit() {
    this.formSubmitted = true;

  }

  onSubmitFinished() {
    // Timeout just so we can see it happening when testing locally
    // also not a big deal to have this in prod env, barely noticeable
    // doesnt justify calling StsConfigService.isProduction
    // if (r) {
    //   try {
    //     r.detectChanges();
    //   } catch (ex) {
    //     console.log('detectChanges external - onSubmitFinished -> ' + ex);
    //   }
    // }
    setTimeout(() => {
      this.formSubmitted = false;
      // try {
      //   this.ref.detectChanges();
      // } catch (ex) {
      //   console.log('detectChanges - onSubmitFinished -> ' + ex);
      // }
    }, 500);
  }

  onRenderingComplete(spanCMS) {
    this.noCmsText = !spanCMS.innerHTML;
    // this.ref.detectChanges();
  }
}
